export default {
  isAuthenticated: (state) => state.isAuthenticated,
  userName: (state) => state.user?.name || "Guest",
  user: (state) => state.user,
  isVerified: (state) => state.user?.isVerified || false,
  csrfToken: (state) => state.csrfToken,
  isLoading: (state) => state.loading,
};
